import React, { useEffect, useState } from "react";
import Login from "./Login.jsx";
import Register from "./Register.jsx";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeCookies } from "../../services/Cookies.jsx";
import { setloggedIn } from "../../store/slices/userSlice.js";
import { useResponsive } from "../../hooks/useResponsive.js";

export default function AuthComponent() {
  const { isMobile } = useResponsive();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("login");
  const dispatch = useDispatch();

  useEffect(() => {
    const tab = searchParams?.get("tab")?.trim();
    if (tab) {
      if ((tab != "login" && tab != "register") || tab == "undefined") {
        setActiveTab("login");
      }
      setActiveTab(tab);
    } else {
      setActiveTab("login");
    }
  }, [searchParams?.get("tab")]);

  useEffect(() => {
    dispatch(setloggedIn(false));
    removeCookies("token");
  }, []);

  return (
    <>
      {!isMobile ? (
        <div className="auth-bg flex min-h-screen w-full justify-center overflow-x-hidden overflow-y-auto bg-[#f9f9f9] px-4 py-6">
          <div className={`my-auto w-full bg-white rounded-2xl shadow-xl ${activeTab === "register" ? "max-w-[560px] p-6 sm:p-8" : "max-w-md p-8 sm:p-10"}`}>
            <div className="flex justify-center mb-6">
              <img
                src="/assets/logo/logo.png"
                alt="logo"
                className="h-16 sm:h-20 w-40 sm:w-48 object-contain"
              />
            </div>
            <div>
              {activeTab === "login" ? <Login /> : <Register />}
            </div>
          </div>
        </div>
      ) : (
        <div className="mobile-dashboard min-h-svh w-full overflow-x-hidden overflow-y-auto bg-blue-50">
          <div className="mx-auto w-full max-w-lg px-4 pb-10 pt-8">
            <div className="mb-6 flex justify-center">
              <img
                src="/assets/logo/logo.png"
                alt="logo"
                className="h-14 w-40 max-w-full object-contain"
              />
            </div>
            {activeTab === "login" ? <Login /> : <Register />}
          </div>
        </div>
      )}
    </>
  );
}
